import useBlockedUsers from '@contexts/useBlockedUsers';
import type { Profile } from '@sunrise-ui/api/profile';
import { PersonSearch as CompositePersonSearch } from '@sunrise-ui/composites';
import React from 'react';
import type { DimensionValue } from 'react-native';

type Props = {
  onSelect: (profile: Profile) => void | Promise<void>;
  width?: DimensionValue;
  maxHeight?: number;
  hiddenIds?: string[];
  searchType?: 'connections' | 'users';
  profileResultSize?: 'small' | 'medium';
  profileResultOneLineText?: boolean;
};

export default function PersonSearch({
  onSelect,
  width,
  maxHeight,
  hiddenIds,
  profileResultSize,
  profileResultOneLineText,
}: Props) {
  const { isUserBlocked } = useBlockedUsers();

  return (
    <CompositePersonSearch
      onSelect={(profile) => {
        if (!isUserBlocked(profile.user_id)) {
          return onSelect(profile);
        }
        return undefined;
      }}
      width={width}
      maxHeight={maxHeight}
      hiddenIds={hiddenIds}
      profileResultSize={profileResultSize}
      profileResultOneLineText={profileResultOneLineText}
    />
  );
}
